import type { NextPage } from 'next'
import { BasicPage } from '@/client/modules/BasicPage'
import { IBasicPage } from '@/client/modules/BasicPage/types'
import { getCMSContent } from '@/client/utils'

const LegalWarning: NextPage<IBasicPage> = (data) => <BasicPage {...data} />

export async function getStaticProps({ defaultLocale, locale }) {
  const data = await getCMSContent(defaultLocale, locale, 'LEGAL_WARNING')

  if (!data?.content) return { revalidate: 60, notFound: true }

  return {
    revalidate: 10,
    props: { ...data }
  }
}

export default LegalWarning
